module.exports = __webpack_public_path__ + "img/image3.766535a.png";